"use client";

import dynamic from "next/dynamic";

const AnalyticsComponent = dynamic(
  () =>
    import("@vercel/analytics/react").then((mod) => ({
      default: mod.Analytics,
    })),
  {
    ssr: false,
    loading: () => null,
  },
);

export function Analytics() {
  return <AnalyticsComponent />;
}
